export default __webpack_public_path__ + "static/media/temp-7.d4a2764d.svg";